import React, {Component} from "react";
import {$} from "../../index";
import {rd, route, routes} from "../../vars/rd";
import {connect} from "react-redux";
import PageBack from "../components/buttons/page-back";


class SearchMent extends Component {
    searchRef;
    keydownHandler;
    constructor(props) {
        super(props);

        const source = props.hasOwnProperty("source") ? props.source : 'channel';
        const query = props.hasOwnProperty("query") ? props.query : '';

        this.keydownHandler = this.eventKeydown.bind(this);

        this.state = {
            source,
            query,
            business: rd.category.business,
            theme: rd.category.theme,
            genre: rd.category.genre,
        }
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    componentDidMount() {
        document.addEventListener('keydown', this.keydownHandler);

        // if(this.searchRef) this.searchRef.focus();
        // this.initCustomView();
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keydownHandler);

        $(".custom-select-trigger").off("click");
        $(".custom-option").off("click");

        $(this.searchRef).closest(".search-wrap").find(".custom-select-wrapper").remove();
        this.searchRef = null;
    }

    initCustomView() {
        const $this = this;

        $(".custom-select").each(function() {
            const classes = $(this).attr("class");
            // const id = $(this).attr("id");
            // const name = $(this).attr("name");

            // placeholder 속성이 없는 경우 기본값 설정
            const placeholderText = $(this).attr("placeholder") || "선택하세요";

            let template = '<div class="' + classes + '">';
            template += '<span class="custom-select-trigger">' + placeholderText + '</span>';
            template += '<div class="custom-options">';

            $(this).find("option").each(function() {
                template += '<span class="custom-option ' + ($(this).attr("class") || '') + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
            });

            template += '</div></div>';

            $(this).wrap('<div class="custom-select-wrapper"></div>');
            $(this).hide();
            $(this).after(template);
        });

        // 첫 번째 옵션에 hover 시 클래스를 추가/제거
        $(".custom-option:first-of-type").hover(
            function() {
                $(this).closest(".custom-options").addClass("option-hover");
            },
            function() {
                $(this).closest(".custom-options").removeClass("option-hover");
            }
        );

        // select 클릭 시 드롭다운 열기
        $(".custom-select-trigger").on("click", function(event) {
            $('html').one("click", function() {
                $(".custom-select").removeClass("opened");
            });

            $(this).closest(".custom-select").toggleClass("opened");
            event.stopPropagation(); // event 객체 명시적으로 전달
        });

        // 옵션 클릭 시 선택 반영
        $(".custom-option").on("click", function() {
            const source = $(this).data("value");
            $this.sourceChange(source);

            const $select = $(this).closest(".custom-select-wrapper").find("select");
            $select.val(source); // select 요소 값 변경
            $(this).closest(".custom-options").find(".custom-option").removeClass("selection");
            $(this).addClass("selection");
            $(this).closest(".custom-select").removeClass("opened");
            $(this).closest(".custom-select").find(".custom-select-trigger").text($(this).text());
        });
    }

    eventKeydown(event) {
        const isInputFocused = document.activeElement === this.searchRef;
        if (isInputFocused && event.key === "Enter") {
            this.searchProcess();
        }
    }

    sourceChange(source) {
        this.setState({source})
    }

    queryChange(query) {
        this.setState({query})
    }

    searchClear() {
        this.setState({query: ''})
    }

    searchProcess() {
        const query = this.state.query;
        if(!query) return;

        route(routes.search_result_ment, query);
    }

    get business() {
        return this.state.business || [];
    }

    get theme() {
        return this.state.theme || [];
    }

    get genre() {
        return this.state.genre || [];
    }

    render() {
        return (
            <div className="search-wrap">
                <div className="search-box">
                    <div className="search-bar">
                        <PageBack />
                        {/*<div className="select-wrap">*/}
                        {/*    <div className="select-menu">*/}
                        {/*        <div className="select-box">*/}
                        {/*            <select name="sources" id="sources"*/}
                        {/*                    className="custom-select sources"*/}
                        {/*                    placeholder={type_search.channel}*/}
                        {/*                    onChange={e => this.sourceChange(e.target.value)}>*/}
                        {/*                {*/}
                        {/*                    Object.keys(type_search).map(searchKey => {*/}
                        {/*                        return <option value={searchKey}*/}
                        {/*                                       key={searchKey}>{type_search[searchKey]}</option>*/}
                        {/*                    })*/}
                        {/*                }*/}
                        {/*            </select>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="input-wrap">
                            <input type="text" name="query" id="query"
                                   className="input-w3"
                                   placeholder="안내멘트 제목, 스크립트로 검색"
                                   ref={el => {this.searchRef = el}}
                                   value={this.state.query}
                                   onChange={e => this.queryChange(e.target.value)}/>
                            {
                                this.state.query.length > 0 ?
                                    <span className="btn-sch2" onClick={() => this.searchClear()}><img src="/images/icon-del2.png" alt="검색어 삭제"/></span> : null
                            }
                            <span className="btn-sch"><img src="/images/icon-sch2.png" alt={''} onClick={() => this.searchProcess()}/></span>
                        </div>
                    </div>
                </div>
                <div className="search-contents">
                </div>
            </div>
        );
    }
}

export default connect()(SearchMent);


// WEBPACK FOOTER //
// ./src/pages/search/search.ment.jsx